import { Box, Chip } from "@mui/material"
import { CloseOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"

import type { Order } from "@/graphql/codegen/graphql"

interface PurchaseOrderSelectionChipsProps {
  selectedPurchaseOrders: Order[]
  onRemove: (purchaseOrderToRemove: Order) => void
}

export const PurchaseOrderSelectionChips: FC<PurchaseOrderSelectionChipsProps> = ({
  selectedPurchaseOrders,
  onRemove,
}) => {
  if (selectedPurchaseOrders.length === 0) {
    return null
  }

  return (
    <Box className='flex flex-wrap gap-2'>
      {selectedPurchaseOrders.map((purchaseOrder) => (
        <Chip
          key={purchaseOrder.orderId}
          label={purchaseOrder.orderId}
          variant='filled'
          color='primary'
          size='small'
          onDelete={() => onRemove(purchaseOrder)}
          deleteIcon={<CloseOutlined className='text-gray-900' />}
          data-testid={`selected-po-chip-${purchaseOrder.orderId}`}
          className='rounded-sm text-xs text-gray-900'
        />
      ))}
    </Box>
  )
}
